<template>
  <div class="container">
    <div v-if="myCollectList.length > 0">
      <div
        v-for="item in myCollectList"
        :key="item.id"
        style="margin-bottom: 10px; border-bottom: 1px solid #ccc"
      >
        <el-row>
          <el-col :span="22">
            <el-row style="margin-bottom: 6px">
              <el-col :span="2">课程名称</el-col>
              <el-col :span="20" style="color: #777">{{
                item.courseName
              }}</el-col>
            </el-row>
            <el-row style="margin-bottom: 6px">
              <el-col :span="2">课时名称</el-col>
              <el-col :span="20" style="color: #777">{{ item.title }}</el-col>
            </el-row>
            <el-row style="margin-bottom: 6px">
              <el-col :span="2">资料类型</el-col>
              <el-col :span="20" style="color: #777">
                <div v-if="type == 1">视频</div>
                <div v-if="type == 2">文档</div>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 6px">
              <el-col :span="2">收藏时间</el-col>
              <el-col :span="20" style="color: #777">{{
                item.ctime | formatDate
              }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="1">
            <el-button
              v-if="type == 2"
              type="primary"
              size="mini"
              style="margin-top: 24px"
              @click="checkMaterial(item.courseId, item.sectionId)"
            >
              查看
            </el-button>
            <el-button
              v-if="type == 1"
              type="primary"
              size="mini"
              style="margin-top: 24px"
              @click="checkMaterial(item.courseId, item.sectionId)"
            >
              播放
            </el-button>
            <el-button
              type="text"
              size="mini"
              style="margin: 18px 0 0 4px; color: #666"
              @click="cancelCollect(item.id)"
            >
              取消收藏
            </el-button>
          </el-col>
        </el-row>
      </div>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObj.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageObj.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      >
      </el-pagination>
    </div>
    <div v-else class="imgContainer">
      <img src="@/static/images/1710091304011eie.png" alt="" />
    </div>
  </div>
</template>

<script>
import * as api from '@/api/myCollect/myCollect'
export default {
  data() {
    return {
      type: this.$route.query.type || 2,
      myCollectList: [],
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
    }
  },
  created() {
    this.getMyCollectList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  filters: {
    formatDate(date) {
      const dateee = new Date(date).toJSON()
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
  },
  methods: {
    async getMyCollectList() {
      const uid = this.getUId
      const type = this.type
      const { page, pageSize } = this.pageObj
      const res = (await api.getCollectionList({ uid, type, page, pageSize }))
        .data
      const { code, data } = res
      if (code === 100000) {
        this.myCollectList = data.list
        this.total = data.total
      }
    },
    checkMaterial(courseId, sectionId) {
      window.open(`${this.url}/course/watch/${courseId}_${sectionId}.html`)
    },
    async cancelCollect(id) {
      const res = (await api.cancelCollection({ id })).data
      const { code, msg } = res
      if (code === 100000) {
        this.getMyCollectList()
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },
    //分页
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getMyCollectList()
    },
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getMyCollectList()
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding: 8px 16px 0;
  background-color: #fff;
  .el-col {
    font-size: 14px;
  }
  .imgContainer {
    display: flex;
    justify-content: center;
  }
}
</style>